/**
 * YouTube functionality
 * @class
 */
export default class YouTube {
    /**
     * @constructor
     * @param {HTMLElement} element The video root element
     */
    constructor(element, videoId) {
        /**
         * Dispatch the broadcast event.
         *
         * This is used to pause any other videos that are playing on the page.
         *
         * @param {int} eventData
         *   The player state.
         */
        this.dispatchBroadcastEvent = (eventData) => {
            const broadcastEvent = new Event('videoPlayerStateChange');
            broadcastEvent.playerState = eventData;
            broadcastEvent.playerVideoId = this.id;
            document.body.dispatchEvent(broadcastEvent);
        };
        /**
         * Handle the global player state change event.
         *
         * @param {Event} event
         *   A triggered `videoPlayerStateChange` event.
         */
        this.handleGlobalVideoPlayerStateChange = (event) => {
            var _a;
            if (event.playerVideoId !== this.id && this.components.player) {
                if (((_a = this.player) === null || _a === void 0 ? void 0 : _a.getPlayerState()) === YT.PlayerState.PLAYING) {
                    this.player.pauseVideo();
                }
            }
        };
        this.el = element;
        this.id = videoId;
        this.components = {
            poster: this.el.querySelector('[data-component="VideoPoster"]'),
            player: this.el.querySelector('[data-component="VideoPlayer"]')
        };
        /**
         * An attribute to handle the debouncing of the YT player state change.
         *
         * @type {null}
         */
        this.stateDebounce = null;
        if (this.components.poster) {
            this.components.poster.addEventListener('click', this.handlePosterClick.bind(this));
        }
        this.registerEvents();
        // console.log('YouTube YouTube', this)
    }
    /**
     * Handle the poster click event.
     */
    handlePosterClick() {
        if (!this.player) {
            this.playerCreate(1);
        }
    }
    /**
     * Create the YT player object.
     *
     * @param {int} autoPlay
     *   An integer indicating whether the player should start playing once created.
     */
    playerCreate(autoPlay) {
        if (this.components.player) {
            this.player = new window.YT.Player(this.components.player, {
                videoId: this.id,
                width: '100%',
                height: '100%',
                playerVars: {
                    autoplay: autoPlay,
                    disablekb: 0,
                    fs: 0,
                    controls: 1,
                    modestbranding: 0,
                    playsinline: 0,
                    enablejsapi: 1,
                    origin: '*',
                },
                events: {
                    // 'onReady'      : this.playerReady.bind(this),
                    'onStateChange': this.playerStateChange.bind(this),
                }
            });
        }
    }
    /**
     * Handle the player state change.
     *
     * @param {{data: int}} event
     *   The triggered event.
     */
    playerStateChange(event) {
        if (this.stateDebounce) {
            clearTimeout(this.stateDebounce);
        }
        this.stateDebounce = setTimeout(() => {
            if (event.data === YT.PlayerState.PLAYING) {
                this.dispatchBroadcastEvent(event.data);
            }
            this.stateDebounce = null;
        }, 250);
    }
    /**
     * Register the required event listeners
     */
    registerEvents() {
        document.body.addEventListener('videoPlayerStateChange', this.handleGlobalVideoPlayerStateChange.bind(this));
    }
}
